import { CSSProperties, SVGProps } from 'react'

const StudentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={
      {
        enableBackground: 'new 0 0 60 60'
      } as CSSProperties
    }
    viewBox="0 0 60 60"
    {...props}
  >
    <circle
      cx={30}
      cy={30}
      r={28}
      style={{
        fill: '#d3b1e2'
      }}
    />
    <path
      d="m45.3 23.2-14.1-7c-.1-.1-.4-.2-.8-.3h-.8c-.3.1-.7.2-.8.3l-14.1 7c-.5.2-.8.8-.8 1.3 0 .6.3 1.1.8 1.3l2.1 1.1v9c0 .4 0 1 .2 1.5.1.4.4.8.7 1.1.4.4.9.6 1.3.8l9.3 4.3c.3.1.7.3 1.1.4.3.1.7.1 1 0 .4-.1.8-.3 1.1-.4l9.3-4.3c.4-.2.9-.4 1.3-.8.3-.3.6-.7.7-1.1.2-.5.2-1.1.2-1.5v-9l2.1-1.1c.5-.2.8-.8.8-1.3.2-.5-.1-1-.6-1.3zM40.2 36.5c-.1.1-.2.1-.5.2L30.4 41c-.2.1-.3.1-.4.2-.1 0-.2-.1-.4-.2l-9.3-4.3c-.3-.1-.4-.2-.5-.2v-8.1l9 4.5c.1.1.4.2.8.3h.8c.3-.1.7-.2.8-.3l4.7-2.3v2.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-4.2l1.5-.7V36c-.2.2-.2.4-.2.5zm-2.9-9.9-6.7-3.3c-.7-.4-1.6-.1-2 .7-.4.7-.1 1.6.7 2l4.7 2.3-4 2-11.3-5.7L30 18.9l11.3 5.7-4 2z"
      style={{
        fill: '#fff'
      }}
    />
  </svg>
)
export default StudentIcon
